export default __webpack_public_path__ + "static/media/sandfloor.5aa6ead7.png";